module.exports = "/images/checkbox-initial.svg?6df20ec1ddab5196d6e6e547a3a7f206";